import { render } from "./CompanyAssetTypeModal.vue?vue&type=template&id=11c74acc"
import script from "./CompanyAssetTypeModal.vue?vue&type=script&lang=js"
export * from "./CompanyAssetTypeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__